import { formatCurrency, formatDate } from "@utils/index";
import { Modal } from "@components/index";
import "./index.scss";

const BookingDetailsModal = ({ isOpen, onClose, booking }) => {
  if (!booking) return null;

  const detailSections = [
    {
      title: "Partner & Transaction Details",
      fields: [
        { label: "Partner ID", value: booking.partner_id },
        { label: "Transaction ID", value: booking.transaction_id },
        {
          label: "Booking DateTime",
          value: new Date(booking.booking_datetime).toLocaleString(),
        },
        // { label: 'Product Version', value: booking.product_version },
      ],
    },
    {
      title: "Passenger Details",
      fields: [
        { label: "Passenger Name", value: booking.passenger_name },
        { label: "Age", value: `${booking.age} years` },
        { label: "Gender", value: booking.gender === "M" ? "Male" : "Female" },
        { label: "Seat Preference", value: booking.seat_preference },
      ],
    },
    {
      title: "Customer Information",
      fields: [
        { label: "Customer Name", value: booking.customer_name },
        { label: "Customer ID", value: booking.customer_id },
        { label: "Email", value: booking.email },
        { label: "Mobile Number", value: booking.mobile_number },
        { label: "Date of Birth", value: formatDate(booking.customer_dob) },
      ],
    },
    {
      title: "Booking Status & Confirmation",
      fields: [
        {
          label: "Ticket Status at Booking",
          value: booking.ticket_status_at_booking,
        },
        { label: "Current Ticket Status", value: booking.ticket_status },
        { label: "Chart Status", value: booking.chart_status },
        {
          label: "Confirmation Probability",
          value: `${booking.confirmation_probability}%`,
        },
        {
          label: "Eligibility Flag",
          value: booking.eligibility_flag ? "Eligible" : "Not Eligible",
        },
      ],
    },
    {
      title: "Train & Journey Details",
      fields: [
        { label: "PNR Number", value: booking.pnr_number },
        { label: "Train Name", value: booking.train_name },
        { label: "Train Number", value: booking.train_number },
        { label: "From Station", value: booking.from_station },
        { label: "To Station", value: booking.to_station },
        { label: "Journey Date", value: formatDate(booking.journey_date) },
        { label: "Travel Class", value: booking.travel_class },
      ],
    },
    {
      title: "Financial & Premium Details",
      fields: [
        { label: "Ticket Fare", value: formatCurrency(booking.ticket_fare) },
        {
          label: "Premium Amount",
          value: formatCurrency(booking.premium_amount),
        },
        { label: "Payment Status", value: booking.payment_status },
        {
          label: "Train Secure Opt-in",
          value: booking.train_secure_optin ? "Yes" : "No",
        },
        {
          label: "Fare Threshold",
          value: formatCurrency(booking.fare_threshold),
        },
        {
          label: "Probability Threshold",
          value: `${booking.probability_threshold}%`,
        },
      ],
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="booking-details-modal"
      showCloseIcon={false}
    >
      <div className="booking-details-modal__header">
        <h2 className="booking-details-modal__title">
          Booking Details - {booking.pnr_number}
        </h2>
        <button
          className="booking-details-modal__close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>

      <div className="booking-details-modal__content">
        {detailSections.map((section, index) => (
          <div key={index} className="booking-details-modal__section">
            <h3 className="booking-details-modal__section-title">
              {section.title}
            </h3>
            <div className="booking-details-modal__fields">
              {section.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="booking-details-modal__field">
                  <span className="booking-details-modal__label">
                    {field.label}:
                  </span>
                  <span className="booking-details-modal__value">
                    {field.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default BookingDetailsModal;
